import SvgBarStyle from './SvgBar.module.scss';
import * as React from 'react';
import { observer } from 'mobx-react';
import { ISvgBarProps } from './ISvgBarProps';

@observer
export class SvgBar extends React.Component<ISvgBarProps> {
  constructor(props: ISvgBarProps) {
    super(props, undefined);
  }
  calculatePercentageColorOpacity(color?: string, opacity?: number): string {
    //Opacity value between 0 and 100
    //It was implemented because in TPS when printing the opacity in svg images causes problems like scaling and translating the parts where opacity is used.
    if (!color) return 'rgb(255, 255, 255)';

    let hex = color.replace('#', '');
    opacity = opacity / 100;

    //Color that needs to have opacity applied
    let r1 = parseInt(hex.substring(0, 2), 16);
    let g1 = parseInt(hex.substring(2, 4), 16);
    let b1 = parseInt(hex.substring(4, 6), 16);

    //White color
    let r2 = 255;
    let g2 = 255;
    let b2 = 255;

    //Color with opacity blended with white to get a solid color that looks like the color with opacity on white background

    let r3 = Math.round(r2 + (r1 - r2) * opacity);
    let g3 = Math.round(g2 + (g1 - g2) * opacity);
    let b3 = Math.round(b2 + (b1 - b2) * opacity);
    return 'rgb(' + r3 + ',' + g3 + ',' + b3 + ')';
  }

  render() {
    return (
      <g className={SvgBarStyle.SvgBar}>
        <text x={this.props.x} y={this.props.y - 20} className={SvgBarStyle.scoreText}>
          {this.props.scores && this.props.scores.toFixed(1)}
          <animate
            attributeName="height"
            from={this.props.y - 20}
            to={this.props.height - 20}
            dur="0.2s"
            fill="freeze"
          />
          <animate
            attributeName="y"
            from={this.props.height - 20}
            to={this.props.y - 20}
            dur="0.2s"
            fill="freeze"
          />
        </text>
        <rect
          height={this.props.height}
          y={this.props.y}
          width={this.props.width}
          x={this.props.x}
          fill={this.calculatePercentageColorOpacity(this.props.color, 30)}
          stroke={this.props.color}
          strokeDasharray={this.props.height + this.props.width + ',' + this.props.width}
        >
          <animate
            attributeName="height"
            from={this.props.y}
            to={this.props.height}
            dur="0.2s"
            fill="freeze"
          />
          <animate
            attributeName="y"
            from={this.props.height}
            to={this.props.y}
            dur="0.2s"
            fill="freeze"
          />
        </rect>
      </g>
    );
  }
}
